export const prefix = "bat"
export const iconName = "minus-circle"
export const width = 34
export const height = 34
export const ligatures = []
export const unicode = ""
export const svgPathData =
    "M17 0 C 7.582 0 5.2610694e-17 7.582 0 17 C 0 26.418 7.582 34 17 34 C 26.418 34 34 26.418 34 17 C 34 7.582 26.418 5.2610694e-17 17 0z M11.277344 16.039062 L 15.683594 16.039062 L 18.320312 16.039062 L 22.728516 16.039062 C 24.427916 16.039063 24.427916 18.839844 22.728516 18.839844 L 18.320312 18.839844 C 16.500212 18.816844 17.499394 18.816844 15.683594 18.839844 L 11.277344 18.839844 C 9.5780837 18.839844 9.5780837 16.039062 11.277344 16.039062z"

export const definition = {
    prefix,
    iconName,
    icon: [width, height, ligatures, unicode, svgPathData],
}

export const batMinusCircle = definition
